import {
  getApiUsagePackageAppId,
  getApiUsageProPackageAppId,
  getApiUsageProPlusPackageAppId,
} from 'helpers/applications';
import type { Product } from 'interfaces/product-cart';
import { trackEvent } from 'services/event-tracking';

export const API_USAGE_PACKAGE_SCHEDULE_CALL_URL = 'https://calendar.app.google/Ht1U3aCEFM8wkSB88';

export const API_PACKAGE_BOUGHT_EVENT = 'api_package_bought';

export type ApiPackageTier = 'essential' | 'pro' | 'pro+';

// Resolves an app id to its API package tier, or null when it is not one of the
// API package apps for the current environment.
export const getApiUsagePackageTier = (appId?: string | null): ApiPackageTier | null => {
  if (!appId) {
    return null;
  }

  switch (appId) {
    case getApiUsagePackageAppId():
      return 'essential';
    case getApiUsageProPackageAppId():
      return 'pro';
    case getApiUsageProPlusPackageAppId():
      return 'pro+';
    default:
      return null;
  }
};

// The one-hour API consultation is a Pro+ benefit, so the "schedule your
// included API consultation" modal is only offered for the Pro+ package.
export const isApiUsageProPlusPackageApp = (appId?: string | null): boolean => getApiUsagePackageTier(appId) === 'pro+';

export const doesCartIncludeApiUsageProPlusPackage = (products: Product[]): boolean =>
  products.some((product) => product.isMarkedForInstall && isApiUsageProPlusPackageApp(product.id));

// Sends an `api_package_bought` event for each API package add-on that was
// purchased alongside a subscription (the "Frequently bought with LiveChat"
// pre-step). Passing a null event place keeps the event name unprefixed so it
// matches the same event sent from Marketplace and the Developer Console.
export const trackApiPackageBoughtEvents = (products: Product[]): void => {
  products.forEach((product) => {
    const tier = product.isMarkedForInstall ? getApiUsagePackageTier(product.id) : null;

    if (!tier) {
      return;
    }

    trackEvent(API_PACKAGE_BOUGHT_EVENT, null, {
      package: tier,
      source: 'lc',
      appId: product.id,
    });
  });
};
